<template>
  <div 
    class="subprogram-nba-rounds-form"
  >
    <app-back-button
      i18n-code="common.back.default"
    />
    <!-- Title -->
    <h1 class="app-content-title">
      <app-i18n code="entities.subprogram.nba.rounds.edit" v-if="isEditing" />
      <app-i18n code="entities.subprogram.nba.rounds.add" v-if="!isEditing" />
    </h1>

    <div class="app-content-page">
    <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>
      <el-form
        v-if="model"
        v-loading="saveLoading"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
      >

        <!-- Information Subtitle -->
        <h2 class="app-content-subtitle">
          <app-i18n code="entities.subprogram.nba.rounds.form.subtitle" />
        </h2>

        <el-row :gutter="10">
          <!-- Dates -->
          <app-date-range
            :startLabel="fields.startDate.label"
            :endLabel="fields.endDate.label"
            :startDate.sync="model[fields.startDate.name]"
            :endDate.sync="model[fields.endDate.name]"
            :startPlaceholder="dateFormat"
            :endPlaceholder="dateFormat"
            :startFormat="dateFormat"
            :endFormat="dateFormat"
            ref="dateRange"
          />

          <!-- Index -->
          <el-col :lg="12" :md="12" :sm="24">
            <el-form-item
              :label="fields.hostingSchoolDivisionIndex.label"
              :prop="fields.hostingSchoolDivisionIndex.name"
              :required="fields.hostingSchoolDivisionIndex.required"
            >
            <el-select 
              v-model="model[fields.hostingSchoolDivisionIndex.name]"
              :placeholder="i18n('common.select.placeholder')"
              clearable
            >
              <!-- Prefix -->
              <i slot="prefix" class="icon-bookmark" />
              <el-option 
                v-for="item in index"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <!-- Games Configuration String -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item
              :label="fields.gamesConfigurationString.label"
              :prop="fields.gamesConfigurationString.name"
              :required="fields.gamesConfigurationString.required"
            >
              <el-input
                :placeholder="i18n('entities.subprogram.nba.rounds.form.placeholders.gamesConfigurationString')"
                v-model="model[fields.gamesConfigurationString.name]"
              >
                <i
                  slot="prefix"
                  class="icon-calendar"
                />
              </el-input>            
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Form controls -->
        <el-form-item>
          <div class="form-buttons">
            <!-- <router-link :to="{name: 'programList', params: {type}}">
              <el-button type="secondary">
                  <app-i18n code="common.back.default" />
              </el-button>
            </router-link> -->
            <el-button
                class="right"
                :disabled="saveLoading"
                @click="doSubmit"
                type="primary"
            >
              <app-i18n v-if="!isEditing" code="common.add"/>
              <app-i18n v-if="isEditing" code="common.save" />
            </el-button>
          </div>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>
<script>
import { SubprogramRegularSeasonRoundsModel } from '@modules/subprogram/subprogram-regular-season-rounds-model';
import { FormSchema } from '@shared/form/form-schema';
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-subprogram-nba-rounds-form',

  props: {
    roundId: String,
    programId: String,
    subprogramId: String,
    programType: String,
  },

  data() {
    return {
      model: null,
      index: [ 1,2,3,4,5 ],
    };
  },

  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      dateFormat: 'auth/manage/dateFormat',
      record: 'subprogram/nba/rounds/record',
      findLoading: 'subprogram/nba/rounds/findLoading',
      saveLoading: 'subprogram/nba/rounds/saveLoading',
    }),
    subpropertyId() {
      return get(this, 'currentManage.subproperty.id', null);
    },
    propertyId() {
      return get(this, 'currentManage.property.id', null);
    },
		isEditing() {
			return !!this.roundId;
    },
    rules() {
      const { formSchema } = this;
      return formSchema.rules();
    },
    formSchema() {
      const { fields } = this;
      return new FormSchema([
        fields.id,
        fields.startDate,
        fields.endDate,
        fields.hostingSchoolDivisionIndex,
        fields.gamesConfigurationString,
      ]);
    },
    fields() {
      const { dateFormat} = this;
      return new SubprogramRegularSeasonRoundsModel({
        dateFormat,
      }).fields();
    },
  },

  async created() {
    const { formSchema } = this;
    if (this.isEditing) {
      await this.doFindRound({
        id: this.roundId,
        subprogramId: this.subprogramId,
        propertyId: this.propertyId,
        subpropertyId: this.subpropertyId,
        programId: this.programId,
      });
    } else {
      await this.doNew();
      this.model = formSchema.initialValues({
        ...this.record,
      });
    }
    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'subprogram/nba/rounds/doFind',
      doNew: 'subprogram/nba/rounds/doNew',
      doUpdateRound: 'subprogram/nba/rounds/doUpdateRound',
      doCreateRound: 'subprogram/nba/rounds/doCreateRound',
      doFindRound: 'subprogram/nba/rounds/doFindRound',
    }),

    async doSubmit() {
      const { formSchema } = this;
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);
      
      if (this.isEditing) {
        return this.doUpdateRound({
          id,
          subprogramId: this.subprogramId,
          values,
          propertyId: this.propertyId,
          subpropertyId: this.subpropertyId,
          programId: this.programId,
        });
      } else {
        return this.doCreateRound({
          subprogramId: this.subprogramId,
          values,
          propertyId: this.propertyId,
          subpropertyId: this.subpropertyId,
          programId: this.programId,
        });
      }
    },

    i18n(code) {
      return i18n(code);
    },
  },

}
</script>
